import { Route } from "react-router-dom";
import Login from "../pages/Login";
import CallbackMs from "../pages/CallbackMs";
import UpdatePassword from "../pages/UpdatePassword";
import ForgetPassword from "../features/forgetPassword";
import { ROUTES } from "../constants/routes";

export const authRoutes = (
    <>
        <Route path="/" element={<Login />} key="login" />
        <Route path="/login" element={<Login />} key="login_path" />
        <Route path="/callback_ms" element={<CallbackMs />} key="callback_ms" />
        <Route
            path="/updatePassword"
            element={<UpdatePassword />}
            key="updatePassword"
        />
        <Route
            path={ROUTES.forget_password}
            element={<ForgetPassword />}
            key="forget_password"
        />
    </>
);
